import { Component } from '@angular/core';
import { SchoolbelleService } from '@schoolbelle/api/schoolbelle';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalsComponent } from '../modals.component';

@Component({
  selector: 'modal-agreement-accept',
  templateUrl: './agreement-accept.component.html',  
  styleUrls:['./agreement-accept.component.scss'],
})
export class AgreementAcceptComponent extends ModalsComponent {
  constructor(
    private sbe : SchoolbelleService,
    modalRef : BsModalRef,
  ) {
    super(modalRef)
  }


  privacyPolicy;
  termsOfUse; 
  ofAge = false;
  isAcceptAll:boolean = false;
  agreedToTermsOfUse = false;
  agreedToPrivacyPolicy = false;
  showAgreedToTermsOfUse = false;
  showAgreedToPrivacyPolicy = false;

  ngOnInit() : void {
    this.sbe.getPrivacyPolicy().subscribe(privacyPolicy=>this.privacyPolicy =privacyPolicy);
    this.sbe.getTermsOfUse().subscribe(termsOfUse=>this.termsOfUse = termsOfUse);
  }

  fetchPrivacyPolicy () {}

  ngOnDestroy() : void {}

  ok () {
    const ofAge = this.ofAge;
    super.ok({ofAge});
  }

  //
  cancel() {
    this.modalRef.hide(); 
  }

  //
  acceptAll() {
    this.isAcceptAll = !this.isAcceptAll;
    
    if(this.isAcceptAll) {
      this.agreedToTermsOfUse = true;
      this.agreedToPrivacyPolicy = true;
    } else {
      this.agreedToTermsOfUse = false;
      this.agreedToPrivacyPolicy = false;
    }
  }

  setAgreedToTermsOfUse() {
    this.agreedToTermsOfUse = !this.agreedToTermsOfUse;
    this.checkIsAcceptAll();
  }

  setAgreedToPrivacyPolicy() {
    this.agreedToPrivacyPolicy = !this.agreedToPrivacyPolicy;
    this.checkIsAcceptAll();
  }

  checkIsAcceptAll() {
    if(this.agreedToTermsOfUse && this.agreedToPrivacyPolicy) this.isAcceptAll = true;
    else this.isAcceptAll = false;
  }
}